import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
// import notify from '../../Notifications/ToastifyActions';
import notify from '../../../Notifications/ToastifyActions';

function CreateAccountDetailsService(token, data) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/account/createAccountDetails`, data, {
        
        headers: {
            'Authorization': token,
        }
    }).then().
        then(res => {return res.data;
        }).catch(error => {  
            console.log(error)            
            notify.NotifyError("An error occurred while Creating Accounts Details, please try again later.");
            return false;
        
        });
}
export  default CreateAccountDetailsService